module.exports = __webpack_public_path__ + "images/default_images/default_event_thumbnail.6d0037.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/default_images/default_event_thumbnail.png
// module id = 561
// module chunks = 4